export default {
  'get-list': {
    method: 'post',
    url: 'trip/journey/list'
  },
  responseAllocation: {
    method: 'post',
    url: '/partner/trip/journey/allocation/response'
  },
  find: {
    method: 'get',
    url: 'trip/journey/find?key=KEY'
  }
}
